/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
var UserSettings = (function () {
  let onEditControlClick = undefined
  UserSettings = class UserSettings {
    static initClass() {
      onEditControlClick = function (e) {
        e.preventDefault()
        const $el = $(e.currentTarget)

        $($el.data("show-target")).show()
        return $($el.data("hide-target")).hide()
      }
    }
    constructor() {
      $(document).on("click", ".edit-control", e => onEditControlClick(e))

      if ($("#user_type_form input:checked").val() === "3") {
        $("#user_age_groups").hide()
        $("#user_age_groups_form").hide()
      }
      /*
      Submit forms when values change.
      TODO: extract this to a ui component.
      */

      // Record current user type
      let prev = $("#user_type_form input:checked").val()

      $(document).on(
        "change",
        "#user_type_form [data-update-on-change]",
        function (e) {
          let type_complete = false
          const $el = $(this)
          const curr = $("#user_type_form input:checked").val()

          // if changing from other, set as complete. If necessary, we'll set a
          // student level on the server-side
          if (prev === "3" && curr !== "3") {
            type_complete = true
          }

          if ($("#user_type_form input:checked").length) {
            type_complete = true
          }

          if (type_complete) {
            $.ajax({
              type: "patch",
              data: $el.serialize(),
              dataType: "script",
              url: $el.attr("action"),
            })
            return (prev = curr)
          } else {
            alert("At least one user type must be checked")
            return $(e.target).prop("checked", true)
          }
        }
      )

      $(document).on(
        "change",
        "#user_interests_form [data-update-on-change]",
        function (e) {
          let interests_complete = false
          const $el = $(this)

          if ($(".user_interests input:checked").length) {
            interests_complete = true
          }

          if (interests_complete) {
            return $.ajax({
              type: "patch",
              data: $el.serialize(),
              dataType: "script",
              url: $el.attr("action"),
            })
          } else {
            alert("At least one interest must be selected")
            return $(e.target).prop("checked", true)
          }
        }
      )

      $(document).on(
        "change",
        "#user_age_groups_form [data-update-on-change]",
        function (e) {
          let student_levels_complete = false
          const $el = $(this)

          const user_type = $("#user_type_form input:checked").val()
          if (user_type === "3") {
            student_levels_complete = true // other doesn't require student level
          }

          if (
            user_type !== "3" &&
            $(".user_student_levels input:checked:not([disabled])").length
          ) {
            student_levels_complete = true
          }

          if (student_levels_complete) {
            return $.ajax({
              type: "patch",
              data: $el.serialize(),
              dataType: "script",
              url: $el.attr("action"),
            })
          } else {
            alert("At least one grade level must be selected")
            return $(e.target).prop("checked", true)
          }
        }
      )

      $(document).on(
        "change",
        "#email_notifications [data-update-on-change]",
        function (e) {
          const $el = $(this)
          return $.ajax({
            type: "patch",
            data: $el.serialize(),
            dataType: "script",
            url: $el.attr("action"),
          })
        }
      )
    }
  }
  UserSettings.initClass()
  return UserSettings
})()

$(document).on("turbo:load", function () {
  if ($(document.body).hasClass("usersSettingsView")) {
    return new UserSettings()
  }
})
